import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../context/AuthContext';
import { SidebarProvider, useSidebar } from '../context/SidebarContext';
import clsx from 'clsx';

// Inner component that uses sidebar context
function MainContent() {
  const { isCollapsed } = useSidebar();

  return (
    <div className="min-h-screen bg-bg">
      <Sidebar />
      {/* Main content - dynamic margin based on sidebar state */}
      <div className={clsx(
        'transition-all duration-300 ease-in-out',
        isCollapsed ? 'md:ml-20' : 'md:ml-64'
      )}>
        <Header />
        <main className="p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default function MainLayout() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-bg flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-2 border-accent-primary border-t-transparent rounded-full animate-spin" />
          <p className="text-text-muted text-sm">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SidebarProvider>
      <MainContent />
    </SidebarProvider>
  );
}
